
import { Component, BaseMixins, $util, menuRouteHelper} from "@/lib"
import Role from '@/store/modules/system/role/entity';
import {routers} from '@/router/router'
@Component
export default class SetPermission extends BaseMixins{
    loading:boolean = false;
    role = new Role();
    checked = [];
    checkboxConfig = {};
    data = [];

    async created() {
        this.loading = true;
        let id = this.$route.query.id;
        this.role = await this.$store.dispatch({ type: "system/role/get", id: id });
        this.checked = this.role.grantedPermissions;
        this.checkboxConfig = { checkRowKeys: this.checked};
        await this.getAllPermissions();
        this.data = Object.assign([], this.list);
        this.loading = false;
    }

    get menuList () {
        return menuRouteHelper.getMenuByRouterForCurrentUser(routers, this.$store.state.currentUser.permissionList);
    }

    async getAllPermissions() {
        await this.$store.dispatch("system/role/getAllPermissions");
    }


    get list() {
        let menuAuthList = $util.extend(true, [], this.menuList);
        let allPermissionList =  $util.extend(true,[], this.$store.state.system.role.permissions);
        let permissionList = Object.assign([], allPermissionList.filter(item => { return this.hasPermission(item.name);}));
        for (let item of permissionList) {
            let hasPermission = (this.role.grantedPermissions && this.role.grantedPermissions.indexOf(item.name) > -1);
            Object.assign(item, { checked: hasPermission });
        }
        menuAuthList.forEach(item => {
            item.children.forEach(childItem => {
                let thirdList = (childItem.children && !childItem.children.some(item =>{ return item.path == "" || item.path == "/"}))? childItem.children:[];
                if (thirdList.length > 0) {
                    //三级菜单
                    thirdList.forEach(element => {
                        let actions = element.meta && element.meta.access? permissionList.filter(x => { return x.name == element.meta.access[0] || x.name.indexOf(`${element.meta.access[0]}.`) > -1; }):[];
                        Object.assign(element, { actions: actions, children: actions });
                    });
                } else {
                    //二级菜单
                    let actions = childItem.meta && childItem.meta.access? permissionList.filter(x => {
                        //获取所有action   
                        return x.name.indexOf(childItem.meta.access[0] + ".") > -1 || x.name == childItem.meta.access[0];
                    }): [];
                    Object.assign(childItem, { actions: actions, children: actions });
                }
            });
        });
        return menuAuthList;
    }

    selectAll({ selection, checked }) {
        this.data.forEach(item => {  this.selectChange({ checked: checked, row: item });});
    }

    selectChange({ checked, row }) {
        row.checked = checked;
        let children = (row.children && !row.children.some(item =>{ return item.path == "" || item.path == "/"}))? row.children:[];
        if (children.length > 0 && row.actions && row.actions.length > 0) {
            for (let item of row.actions) {
                item.checked = checked;
                let tempIndex = this.checked.indexOf(item.name);
                if (checked) {
                    if (tempIndex == -1) {
                        this.checked.push(item.name);
                    }
                } else {
                    if (tempIndex > -1) {
                        this.checked.splice(tempIndex, 1);
                    }
                }
            }
            (this.$refs["tree-table"] as any).setSelection([row], checked);
        } else {
            children.forEach(item => { this.selectChange({ checked: checked, row: item }); });
        }
    }

    rowClassName({ row }) {
        if (row.children && row.actions) return "hidden-vxe-tree-node-btn";
    }

    async save() {
        let result = (this.$refs["tree-table"] as any).getCheckboxRecords();
        result = result.filter(item => { return item.children == undefined; });
        this.loading = true;
        let requestData = {id: this.role.id, grantedPermissions: result.map(item => { return item.name}) }
        await this.$store.dispatch({ type: "system/role/setAllPermissions", data: requestData });
        this.loading = false;
        this.$Message.success(this.L("Tip.SavedSuccessfully"));
        this.back();
    }

    tableColumn = [
        { type: "checkbox", width: 60, align:"center" },
        { 
            field: "name", treeNode: true, title: this.L("Menu.Menu"), width: 320,
            slots: { default: ({ row }, h) => { return [h("span", this.L(row.meta.title))]; } }
        },
        { 
            field: "actions", title: this.L("Action.Actions"),
            slots: {
                default: ({ row, column }, h) => {
                    let checkBoxItems = [];
                    if (row.actions) {
                        for (let key in row.actions) {
                            checkBoxItems.push(
                                this.$createElement(
                                "Checkbox",
                                {
                                    props: {
                                        //将单元格的值给Input
                                        value: row.actions[key].checked
                                    },
                                    nativeOn: {
                                        change: value => {
                                            row.actions[key].checked = value.target.checked;
                                            if (row.actions[key].checked) {
                                                this.checked.push(row.actions[key].name);
                                            } else {
                                                this.checked.splice( this.checked.indexOf(row.actions[key].name),1);
                                            }
                                            (this.$refs["tree-table"] as any).setSelection([row.actions[key]], value.target.checked);
                                        }
                                    }
                                },
                                    row.actions[key].displayName
                                )
                            );
                        }
                    }
                    return checkBoxItems;
                }
            }
        }
    ];
}
